import { render, staticRenderFns } from "./MemoryXPreview.vue?vue&type=template&id=0e5eddc9&lang=pug&"
import script from "./MemoryXPreview.vue?vue&type=script&lang=js&"
export * from "./MemoryXPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports